
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { LoginService } from './Login.service';

@Injectable()
export class PDFBackupGaurdService implements CanActivate {
  constructor(private router: Router, private _loginService: LoginService) { }
  activate: boolean = true;
  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    {
      const data = await this._loginService.getPDFBackupEnableFlag().toPromise();
      if (data?.toString().toLowerCase() == "true") {
        return true;
      }
      this.router.navigate(['Login'])
      return false
    }
  }
}
